

// import React, { useState } from "react";
// import Table from "react-bootstrap/Table";
// import * as XLSX from "xlsx";
// import axios from "axios";
// import { styled } from "@mui/material/styles";
// import Button from "@mui/material/Button";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import GetAppIcon from "@mui/icons-material/GetApp";
// import Swal from "sweetalert2";
// import { API_BASE_URL } from "../../../utils/index";
// import { useNavigate } from "react-router-dom";
// import { useAuthHeaders } from "../../../components/Token";

// const VisuallyHiddenInput = styled("button")({
//   clip: "rect(0 0 0 0)",
//   clipPath: "inset(50%)",
//   height: 1,
//   overflow: "hidden",
//   position: "absolute",
//   bottom: 0,
//   left: 0,
//   whiteSpace: "nowrap",
//   width: 1,
// });

// const BulkUpload = () => {
//   const [excelFile, setExcelFile] = useState(null);
//   const [typeError, setTypeError] = useState(null);
//   const [excelData, setExcelData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const headers = useAuthHeaders();
//   const navigate = useNavigate();

//   const handleFile = (e) => {
//     e.preventDefault();
//     let fileTypes = [
//       "application/vnd.ms-excel",
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       "text/csv",
//     ];
//     let selectedFile = e.target.files[0];
//     if (selectedFile) {
//       if (selectedFile && fileTypes.includes(selectedFile?.type)) {
//         setTypeError(null);
//         let reader = new FileReader();
//         reader.readAsArrayBuffer(selectedFile);
//         reader.onload = (e) => {
//           setExcelFile(e.target.result);
//         };
//       } else {
//         setTypeError("Please select a valid excel file");
//         setExcelFile(null);
//       }
//     } else {
//       console.log("please select your file");
//     }
//   };

//   const handleFileSubmit = (e) => {
//     e.preventDefault();
//     if (excelFile !== null) {
//       const workbook = XLSX.read(excelFile, { type: "buffer" });
//       const worksheetName = workbook?.SheetNames[0];
//       const worksheet = workbook?.Sheets[worksheetName];
//       const data = XLSX.utils.sheet_to_json(worksheet);
//       setExcelData(data);  // Process all rows
//     }
//   };

//   const uploadFile = () => {
//     if (typeof excelData === "object" && excelData !== null) {
//       if (Object.keys(excelData).length !== 0) {
//         const obj = { products: excelData };

//         setLoading(true);
//         axios
//           .post(`${API_BASE_URL}/admin/bulkupload`, obj, { headers })
//           .then((result) => {
//             setLoading(false);
//             Swal.fire({
//               icon: "success",
//               title: "Product Successfully Uploaded",
//               showConfirmButton: true,
//               timer: 32000,
//               text: result.data.message,
//             });
//             navigate("/newproductsViewPage");
//             setTimeout(() => {
//               navigate("/newproductsViewPage");
//             }, 2000);
//           })
//           .catch((error) => {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               showConfirmButton: true,
//               text: error.response.data.message,
//               timer: 30000,
//             });
//           });
//       }
//     }
//   };

//   const handleCancel = () => {
//     setExcelFile(null);
//     setExcelData(null);
//     setTypeError(null);
//     document.getElementById("fileInput").value = null;
//   };

//   return (

//     <div className="wrapper" style={{ padding: "3%" }}>
//           <h3>Bulk Upload & view</h3>
//           <form
//             className="form-group custom-form bulkupload-file-form"
//             onSubmit={handleFileSubmit}
//             style={{ display: "flex" }}
//           >
//             <input
//               type="file"
//               id="fileInput"
//               className="form-control bulkupload-file-form-input"
//               required
//               onChange={handleFile}
//               style={{ width: "50%", marginRight: "2%" }}
//             />
//             <Button
//               component="label"
//               role={undefined}
//               variant="contained"
//               tabIndex={-1}
//             >
//               View File
//               <VisuallyHiddenInput type="submit" />
//             </Button>
//             <Button
//               component="label"
//               role={undefined}
//               variant="contained"
//               color="success"
//               tabIndex={-1}
//               startIcon={<CloudUploadIcon />}
//               onClick={uploadFile}
//               style={{ marginLeft: "1%" }}
//             >
//               Upload file
//               <VisuallyHiddenInput type="submit" />
//             </Button>
//             <Button
//               variant="contained"
//                     color="primary"
//                     startIcon={<GetAppIcon />}
//                     href="/demo-file.xlsx"  // Ensure this file is in the public folder
//                     download="demo-file.xlsx"
//                     style={{ marginLeft: "1%" }}
//             >
//               Demo File
//             </Button>
//             {excelFile && (
//               <Button
//                 component="label"
//                 role={undefined}
//                 variant="contained"
//                 color="error"
//                 tabIndex={-1}
//                 onClick={handleCancel}
//                 style={{ marginLeft: "2%" }}
//               >
//                 Cancel
//               </Button>
//             )}
//             {typeError && (
//               <div className="alert alert-danger" role="alert">
//                 {typeError}
//               </div>
//             )}
//           </form>

//           <div className="viewer">
//             {excelData ? (
//               <div style={{ width: "90%", overflow: "auto", marginTop: "5%" }}>
//                 <Table striped bordered hover>
//                   <thead>
//                     <tr>
//                       {Object.keys(excelData[0]).map((val, i) => (
//                         <th key={i}>{val}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {excelData.map((data, id) => (
//                       <tr key={id}>
//                         {Object.keys(data).map((d1) => (
//                           <td
//                             style={{ textAlign: "center", textWrap: "nowrap" }}
//                             key={d1}
//                           >
//                             {data[d1]}
//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             ) : (
//               <div style={{color:"red",textTransform:"uppercase"}}>No file is uploaded and Only 50 products data can be uploaded in sinlge Excel file </div>
//             )}
//           </div>
//         </div>
//   );
// };

// export default BulkUpload;


import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GetAppIcon from "@mui/icons-material/GetApp";
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from "xlsx";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../utils/index";
import { useNavigate } from "react-router-dom";
import { useAuthHeaders } from "../../../components/Token";
import { motion } from "framer-motion";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const BulkUpload = () => {
  const [excelFile, setExcelFile] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [loading, setLoading] = useState(false);

  const headers = useAuthHeaders();
  const navigate = useNavigate();

  const handleFile = (e) => {
    const fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    const selectedFile = e.target.files[0];
    if (selectedFile && fileTypes.includes(selectedFile?.type)) {
      setTypeError(null);
      const reader = new FileReader();
      reader.readAsArrayBuffer(selectedFile);
      reader.onload = (e) => setExcelFile(e.target.result);
    } else {
      setTypeError("Please select a valid Excel or CSV file.");
      setExcelFile(null);
    }
  };

  const handleFileSubmit = (e) => {
    e.preventDefault();
    if (excelFile) {
      const workbook = XLSX.read(excelFile, { type: "buffer" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(worksheet);
      setExcelData(data);
    }
  };

  const uploadFile = () => {
    if (excelData?.length > 0) {
      const payload = { products: excelData };
      setLoading(true);
      axios
        .post(`${API_BASE_URL}/admin/bulkupload`, payload, { headers })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Uploaded Successfully",
            text: res.data.message,
            timer: 3000,
            showConfirmButton: false,
          });
          navigate("/newproductsViewPage");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Upload Failed",
            text: err.response?.data?.message || "Unknown error",
          });
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCancel = () => {
    setExcelFile(null);
    setExcelData(null);
    setTypeError(null);
    document.getElementById("fileInput").value = null;
  };

  return (
    <Box p={4}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" gutterBottom>
          Bulk Upload & View
        </Typography>
        <form onSubmit={handleFileSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <input
                accept=".xlsx, .xls, .csv"
                type="file"
                id="fileInput"
                required
                onChange={handleFile}
                style={{ display: "none" }}
              />
              <label htmlFor="fileInput">
                <Button variant="outlined" component="span" fullWidth>
                  Choose File
                </Button>
              </label>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button variant="contained" type="submit">
                View File
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="success"
                startIcon={<CloudUploadIcon />}
                onClick={uploadFile}
                disabled={!excelData}
              >
                Upload File
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                startIcon={<GetAppIcon />}
                href="/demo-file.xlsx"
                download
              >
                Demo File
              </Button>
            </Grid>
            {excelFile && (
              <Grid item xs={12} sm="auto">
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<CancelIcon />}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Grid>
            )}
          </Grid>
        </form>
        {typeError && (
          <Box mt={2}>
            <Alert severity="error">{typeError}</Alert>
          </Box>
        )}
      </motion.div>

      <Box mt={4}>
        {excelData ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {Object.keys(excelData[0]).map((key, i) => (
                      <TableCell key={i}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelData.map((row, idx) => (
                    <TableRow key={idx}>
                      {Object.values(row).map((value, j) => (
                        <TableCell key={j}>{value}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </motion.div>
        ) : (
          <Box mt={3}>
            <Typography color="error" sx={{ textTransform: "uppercase" }}>
              No file is uploaded. Only 50 products can be uploaded at a time.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BulkUpload;

